import React from "react";
import { AcrobatIcon } from "../../../constants/svg";
import { pdf_field_names } from "../../../utils/constants";
import { formatFileSize } from "../../../utils/helper";

const PdfMessage = ({ message }) => {
  const pdfUrl = message[pdf_field_names.url];
  const thumbnailUrl = message[pdf_field_names.thumbnail_url];
  const fileName =
    message[pdf_field_names.file_name] || message.name || "Document.pdf";
  const fileSize = message[pdf_field_names.file_size];

  const hasThumbnail = thumbnailUrl && thumbnailUrl.trim() !== "";

  const handlePdfClick = () => {
    window.open(pdfUrl, "_blank");
  };

  return (
    <div className="pdf-message-container" onClick={handlePdfClick}>
      <div className="pdf-header">
        <div className="pdf-icon">
          <AcrobatIcon />
        </div>
        <div className="pdf-info">
          <div className="pdf-name">{fileName}</div>
          <div className="pdf-size">
            {fileSize ? `${formatFileSize(fileSize)} PDF` : "PDF"}
          </div>
        </div>
      </div>
      {hasThumbnail && (
        <div className="pdf-thumbnail">
          <img
            src={thumbnailUrl}
            alt="PDF Preview"
            className="pdf-thumbnail-image"
          />
        </div>
      )}
    </div>
  );
};

export default PdfMessage;
